import { Injectable } from "@angular/core";
import { StatusCodes } from "@obg/ngx.global";
import { Observable } from "rxjs";

import { CoreHttpClient } from "../../../http-client/http-client.service";

import { MultiDepositLimitConfigService } from "./multi-deposit-limit.config";
import { MultiDepositLimit, MultiDepositLimits } from "./multi-deposit-limit.model";

/**
 * @deprecated [fabric-deprecated] - Use MultiDepositLimitService from app-responsible-gaming instead
 */
@Injectable({
	providedIn: "root",
})
export class MultiDepositLimitService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: MultiDepositLimitConfigService
	) {}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetMultiDepositLimits instead
	 */
	get(): Observable<MultiDepositLimits> {
		return this.httpClient.get<MultiDepositLimits>({
			url: this.config.getMultiDepositLimitEndpoint(),
			suppressErrorLogging: [StatusCodes.Unauthorized],
		});
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.UpdateMultiDepositLimit instead
	 */
	update(params: MultiDepositLimit): Observable<MultiDepositLimits> {
		return this.httpClient.put<MultiDepositLimits>({
			url: this.config.getMultiDepositLimitEndpoint(),
			data: params,
		});
	}
}
